module.exports = __webpack_public_path__ + "media/application/images/icons/editor-unlink-daf568ad986a0edff5e3bffd3390f26f.svg";